interface IOverflowObserverHandler {
  disconnect: () => void;
}

const cancelScheduledRaf = (rafId: number): void => {
  if (rafId) {
    cancelAnimationFrame(rafId);
  }
};

export const observeOverflowChanges = (
  element: HTMLElement | null,
  onChange: () => void,
): IOverflowObserverHandler | null => {
  if (!element || typeof ResizeObserver === 'undefined') {
    return null;
  }

  let rafId = 0;
  const scheduleCheck = () => {
    cancelScheduledRaf(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      onChange();
    });
  };
  const resizeObserver = new ResizeObserver(() => {
    scheduleCheck();
  });

  resizeObserver.observe(element);
  scheduleCheck();

  let mutationObserver: MutationObserver | null = null;

  if (typeof MutationObserver !== 'undefined') {
    mutationObserver = new MutationObserver(() => {
      scheduleCheck();
    });
    mutationObserver.observe(element, {
      childList: true,
      subtree: true,
    });
  }

  return {
    disconnect: () => {
      cancelScheduledRaf(rafId);
      mutationObserver?.disconnect();
      resizeObserver.disconnect();
    },
  };
};
